import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#09281d] px-5 py-16" data-id="element-241">
      <div className="mx-auto max-w-2xl border-2 border-red-400 bg-[#10372a] p-8 text-center sm:p-11" data-id="element-242">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-red-300" data-id="element-243">
          <Clock3Icon className="h-4 w-4" data-id="element-244" /> Offerta a tempo limitato
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-245">
          Il prezzo di lancio scade tra:
        </h2>
        <div className="my-9" data-id="element-246">
          <CountdownTimer size="large" dark data-id="element-247" />
        </div>
        <p className="font-semibold text-white" data-id="element-248">
          Dopodiché, il prezzo aumenterà di 5€ e non tornerà più indietro.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-249">
          <div className="h-3 overflow-hidden border border-red-400/50 bg-[#061b13]" data-id="element-250">
            <div className="h-full w-[72%] bg-red-500" data-id="element-251" />
          </div>
          <div className="mt-3 flex justify-between gap-4 text-[10px] font-bold uppercase tracking-widest" data-id="element-252">
            <span className="text-left text-red-300" data-id="element-253">
              Posti limitati — offerta valida solo per oggi
            </span>
            <span className="shrink-0 text-slate-300" data-id="element-254">72% riscattato</span>
          </div>
        </div>
      </div>
    </section>;
}